import { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { Divider, Text } from '@reveni-io/reveni-ui'

import RMAContext from '@/returns/pages/TransactionRMAPage/context/RMAContext'
import { isRefundMethodVisible } from '@/returns/pages/TransactionRMAPage/TransactionRMAPageContent/helpers'

import RefundMethodSelector from './RefundMethodSelector/RefundMethodSelector'

const RefundMethod = ({ onChangeRefundMethod }) => {
  const { rmaInfo } = useContext(RMAContext)
  const { t } = useTranslation()

  if (!isRefundMethodVisible(rmaInfo)) {
    return null
  }

  return (
    <>
      <Divider />
      <Text type="titleS" style={{ marginBottom: '12px' }}>
        {t('Método de reembolso')}
      </Text>
      <RefundMethodSelector
        refundMethods={rmaInfo.orderInfo?.allowed_refund_methods}
        currency={rmaInfo.orderInfo?.currency}
        onChange={onChangeRefundMethod}
        refundMethod={rmaInfo.orderInfo?.refundType || ''}
      />
    </>
  )
}

export default RefundMethod
